export default "__VITE_ASSET__Ddt_SAL7__"